<mat-card  *ngIf="editAvaluaData">
  <form #loginForm="ngForm">
    <mat-toolbar style="width:100%;">
      <h3 style="float:left;clear:left;padding-left:5px;width:250px">{{ 'propostaMi.estat.avaluacioToolTip' | translate }}</h3>
      <div style="width:150px;float:right;clear:none">
        <button mat-icon-button (click)="onNoClick()" matTooltip="{{ 'common.tancar' | translate }}" attr.aria-label="{{ 'common.tancar' | translate }}" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">close</mat-icon>
        </button>
        <button mat-icon-button (click)="desar()" matTooltip="{{ 'common.desar' | translate }}" attr.aria-label="{{ 'common.desar' | translate }}" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">save</mat-icon>
        </button>
      </div>  
    </mat-toolbar>
  <span style="width:100%">&nbsp;</span>
   <mat-card-content class="scroll">
      <div style="float:left;clear:left;width:100%;font-weight:bold;">
        {{ 'avaluacioDialog.outlineSection' | translate }}
      </div>
      <mat-form-field style="float:left;clear:left;width:250px">
       <mat-select style="width:250px" [(ngModel)]="editAvaluaData.avaluacio" placeholder="{{ 'avaluacioDialog.analisiCriterisAvaluacio' | translate }}" name="avaluacio">
         <mat-select-trigger>
            <span class="select-trigger"
              [ngStyle]="{
              'background-color': getColorPerValor(editAvaluaData.avaluacio),
              'padding': '4px 8px',
              'display': 'inline-block',
              'border-radius': '4px',
              'color': 'white',
              'width': '90%',
'min-height': '24px'
              }"
            >
            {{ getNomPerValor(editAvaluaData.avaluacio) }}
            </span>
          </mat-select-trigger>
          <mat-option *ngFor="let opcio of opcions"
              [value]="opcio.valor" [ngStyle]="{'background-color': opcio.color}">
              {{ opcio.nom }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="float:left;clear:left;width:250px">
       <mat-select style="width:250px" [(ngModel)]="editAvaluaData.competidors" placeholder="{{ 'avaluacioDialog.analisiCompetidors' | translate }}" name="competidors">
         <mat-select-trigger>
            <span class="select-trigger"
              [ngStyle]="{
              'background-color': getColorPerValor(editAvaluaData.competidors),
              'padding': '4px 8px',
              'display': 'inline-block',
              'border-radius': '4px',
              'color': 'white',
              'width': '90%',
'min-height': '24px'
              }"
            >
            {{ getNomPerValor(editAvaluaData.competidors) }}
            </span>
          </mat-select-trigger>
          <mat-option *ngFor="let opcio of opcions"
              [value]="opcio.valor" [ngStyle]="{'background-color': opcio.color}">
              {{ opcio.nom }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="float:left;clear:left;width:250px">
       <mat-select style="width:250px" [(ngModel)]="editAvaluaData.revisio" placeholder="{{ 'avaluacioDialog.revisioLiteratura' | translate }}" name="revisio">
          <mat-select-trigger>
            <span class="select-trigger"
              [ngStyle]="{
              'background-color': getColorPerValor(editAvaluaData.revisio),
              'padding': '4px 8px',
              'display': 'inline-block',
              'border-radius': '4px',
              'color': 'white',
              'width': '90%',
'min-height': '24px'
              }"
            >
            {{ getNomPerValor(editAvaluaData.revisio) }}
            </span>
          </mat-select-trigger>
          <mat-option *ngFor="let opcio of opcions"
              [value]="opcio.valor" [ngStyle]="{'background-color': opcio.color}">
              {{ opcio.nom }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="float:left;clear:left;width:250px">
       <mat-select style="width:250px" [(ngModel)]="editAvaluaData.enfocament" placeholder="{{ 'avaluacioDialog.enfocamentTecnic' | translate }}" name="enfocament">
          <mat-select-trigger>
             <span class="select-trigger"
              [ngStyle]="{
              'background-color': getColorPerValor(editAvaluaData.enfocament),
              'padding': '4px 8px',
              'display': 'inline-block',
              'border-radius': '4px',
              'color': 'white',
              'width': '90%',
'min-height': '24px'
              }"
            >
            {{ getNomPerValor(editAvaluaData.enfocament) }}
            </span>
          </mat-select-trigger>
          <mat-option *ngFor="let opcio of opcions"
              [value]="opcio.valor" [ngStyle]="{'background-color': opcio.color}">
              {{ opcio.nom }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="float:left;clear:left;width:250px">
       <mat-select style="width:250px" [(ngModel)]="editAvaluaData.perfils" placeholder="{{ 'avaluacioDialog.perfilsRequerits' | translate }}" name="perfils">
          <mat-select-trigger>
             <span class="select-trigger"
              [ngStyle]="{
              'background-color': getColorPerValor(editAvaluaData.perfils),
              'padding': '4px 8px',
              'display': 'inline-block',
              'border-radius': '4px',
              'color': 'white',
              'width': '90%',
'min-height': '24px'
              }"
            >
            {{ getNomPerValor(editAvaluaData.perfils) }}
            </span>
          </mat-select-trigger>
          <mat-option *ngFor="let opcio of opcions"
              [value]="opcio.valor" [ngStyle]="{'background-color': opcio.color}">
              {{ opcio.nom }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div style="float:left;clear:left;width:100%;font-weight:bold;">
        {{ 'projectsList.camps.socis' | translate }}
      </div>
      <mat-form-field style="float:left;clear:left;width:250px">
       <mat-select style="width:250px" [(ngModel)]="editAvaluaData.reunions_socis" placeholder="{{ 'avaluacioDialog.reunionsSocis' | translate }}" name="reunions_socis">
           <mat-select-trigger>
            <span class="select-trigger"
              [ngStyle]="{
              'background-color': getColorPerValor(editAvaluaData.reunions_socis),
              'padding': '4px 8px',
              'display': 'inline-block',
              'border-radius': '4px',
              'color': 'white',
              'width': '90%',
'min-height': '24px'
              }"
            >
            {{ getNomPerValor(editAvaluaData.reunions_socis) }}
            </span>
          </mat-select-trigger>
          <mat-option *ngFor="let opcio of opcions"
              [value]="opcio.valor" [ngStyle]="{'background-color': opcio.color}">
              {{ opcio.nom }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="float:left;clear:left;width:250px">
       <mat-select style="width:250px" [(ngModel)]="editAvaluaData.acord_socis" placeholder="{{ 'avaluacioDialog.acordTasquesPressupost' | translate }}" name="acord_socis">
         <mat-select-trigger>
            <span class="select-trigger"
              [ngStyle]="{
              'background-color': getColorPerValor(editAvaluaData.acord_socis),
              'padding': '4px 8px',
              'display': 'inline-block',
              'border-radius': '4px',
              'color': 'white',
              'width': '90%',
'min-height': '24px'
              }"
            >
            {{ getNomPerValor(editAvaluaData.acord_socis) }}
            </span>
          </mat-select-trigger>
          <mat-option *ngFor="let opcio of opcions"
              [value]="opcio.valor" [ngStyle]="{'background-color': opcio.color}">
              {{ opcio.nom }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="float:left;clear:left;width:250px">
       <mat-select style="width:250px" placeholder="{{ 'avaluacioDialog.aportacionsSocis' | translate }}" name="aportacions_socis" [(ngModel)]="editAvaluaData.aportacions_socis">
        <mat-option *ngFor="let opcio of opcions"
              [value]="opcio.valor" [ngStyle]="{'background-color': opcio.color}">
              {{ opcio.nom }}
          </mat-option>
         <mat-select-trigger>
            <span class="select-trigger"
              [ngStyle]="{
              'background-color': getColorPerValor(editAvaluaData.aportacions_socis),
              'padding': '4px 8px',
              'display': 'inline-block',
              'border-radius': '4px',
              'color': 'white',
              'width': '90%',
'min-height': '24px'
              }"
            >
            {{ getNomPerValor(editAvaluaData.aportacions_socis) }}
            </span>
          </mat-select-trigger>
        </mat-select>
      </mat-form-field>
      <div style="float:left;clear:left;width:100%;font-weight:bold;">
        {{ 'avaluacioDialog.eoiPropostaSection' | translate }}
      </div>
      <mat-form-field style="float:left;clear:left;width:250px">
       <mat-select style="width:250px" placeholder="{{ 'avaluacioDialog.estructuraFormat' | translate }}" name="estructura_tecnica" [(ngModel)]="editAvaluaData.estructura_tecnica">
         <mat-select-trigger>
            <span class="select-trigger"
              [ngStyle]="{
              'background-color': getColorPerValor(editAvaluaData.estructura_tecnica),
              'padding': '4px 8px',
              'display': 'inline-block',
              'border-radius': '4px',
              'color': 'white',
              'width': '90%',
'min-height': '24px'
              }"
            >
            {{ getNomPerValor(editAvaluaData.estructura_tecnica) }}
            </span>
          </mat-select-trigger>
        <mat-option *ngFor="let opcio of opcions"
              [value]="opcio.valor" [ngStyle]="{'background-color': opcio.color}">
              {{ opcio.nom }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="float:left;clear:left;width:250px">
       <mat-select style="width:250px" placeholder="{{ 'avaluacioDialog.goldenParagraphs' | translate }}" name="golden_tecnica" [(ngModel)]="editAvaluaData.golden_tecnica">
         <mat-select-trigger>
            <span class="select-trigger"
              [ngStyle]="{
              'background-color': getColorPerValor(editAvaluaData.golden_tecnica),
              'padding': '4px 8px',
              'display': 'inline-block',
              'border-radius': '4px',
              'color': 'white',
              'width': '90%',
'min-height': '24px'
              }"
            >
            {{ getNomPerValor(editAvaluaData.golden_tecnica) }}
            </span>
          </mat-select-trigger>
        <mat-option *ngFor="let opcio of opcions"
              [value]="opcio.valor" [ngStyle]="{'background-color': opcio.color}">
              {{ opcio.nom }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="float:left;clear:left;width:250px">
       <mat-select style="width:250px" placeholder="{{ 'avaluacioDialog.adaptacioCvPerfils' | translate }}" name="adaptacio_cv_perfils" [(ngModel)]="editAvaluaData.adaptacio_cv_perfils">
          <mat-select-trigger>
            <span class="select-trigger"
              [ngStyle]="{
              'background-color': getColorPerValor(editAvaluaData.adaptacio_cv_perfils),
              'padding': '4px 8px',
              'display': 'inline-block',
              'border-radius': '4px',
              'color': 'white',
              'width': '90%',
'min-height': '24px'
              }"
            >
            {{ getNomPerValor(editAvaluaData.adaptacio_cv_perfils) }}
            </span>
          </mat-select-trigger>
        <mat-option *ngFor="let opcio of opcions"
              [value]="opcio.valor" [ngStyle]="{'background-color': opcio.color}">
              {{ opcio.nom }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="float:left;clear:left;width:250px">
       <mat-select style="width:250px" placeholder="{{ 'avaluacioDialog.adaptacioCvEmpresa' | translate }}" name="adaptacio_cv_empresa" [(ngModel)]="editAvaluaData.adaptacio_cv_empresa">
          <mat-select-trigger>
            <span class="select-trigger"
              [ngStyle]="{
              'background-color': getColorPerValor(editAvaluaData.adaptacio_cv_empresa),
              'padding': '4px 8px',
              'display': 'inline-block',
              'border-radius': '4px',
              'color': 'white',
              'width': '90%',
'min-height': '24px'
              }"
            >
            {{ getNomPerValor(editAvaluaData.adaptacio_cv_empresa) }}
            </span>
          </mat-select-trigger>
        <mat-option *ngFor="let opcio of opcions"
              [value]="opcio.valor" [ngStyle]="{'background-color': opcio.color}">
              {{ opcio.nom }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="float:left;clear:left;width:250px">
       <mat-select style="width:250px" placeholder="{{ 'avaluacioDialog.fitxesProjectes' | translate }}" name="fitxes_tecnica" [(ngModel)]="editAvaluaData.fitxes_tecnica">
          <mat-select-trigger>
            <span class="select-trigger"
              [ngStyle]="{
              'background-color': getColorPerValor(editAvaluaData.fitxes_tecnica),
              'padding': '4px 8px',
              'display': 'inline-block',
              'border-radius': '4px',
              'color': 'white',
              'width': '90%',
'min-height': '24px'
              }"
            >
            {{ getNomPerValor(editAvaluaData.fitxes_tecnica) }}
            </span>
          </mat-select-trigger>
        <mat-option *ngFor="let opcio of opcions"
              [value]="opcio.valor" [ngStyle]="{'background-color': opcio.color}">
              {{ opcio.nom }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="float:left;clear:left;width:250px">
       <mat-select style="width:250px" placeholder="{{ 'avaluacioDialog.metodologiaTecnica' | translate }}" name="metodologia_tecnica" [(ngModel)]="editAvaluaData.metodologia_tecnica">
          <mat-select-trigger>
            <span class="select-trigger"
              [ngStyle]="{
              'background-color': getColorPerValor(editAvaluaData.metodologia_tecnica),
              'padding': '4px 8px',
              'display': 'inline-block',
              'border-radius': '4px',
              'color': 'white',
              'width': '90%',
'min-height': '24px'
              }"
            >
            {{ getNomPerValor(editAvaluaData.metodologia_tecnica) }}
            </span>
          </mat-select-trigger>
        <mat-option *ngFor="let opcio of opcions"
              [value]="opcio.valor" [ngStyle]="{'background-color': opcio.color}">
              {{ opcio.nom }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="float:left;clear:left;width:250px">
       <mat-select style="width:250px" placeholder="{{ 'avaluacioDialog.plaTreball' | translate }}" name="pla_tecnica" [(ngModel)]="editAvaluaData.pla_tecnica">
          <mat-select-trigger>
            <span class="select-trigger"
              [ngStyle]="{
              'background-color': getColorPerValor(editAvaluaData.pla_tecnica),
              'padding': '4px 8px',
              'display': 'inline-block',
              'border-radius': '4px',
              'color': 'white',
              'width': '90%',
'min-height': '24px'
              }"
            >
            {{ getNomPerValor(editAvaluaData.pla_tecnica) }}
            </span>
          </mat-select-trigger>
        <mat-option *ngFor="let opcio of opcions"
              [value]="opcio.valor" [ngStyle]="{'background-color': opcio.color}">
              {{ opcio.nom }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="float:left;clear:left;width:250px">
       <mat-select style="width:250px" placeholder="{{ 'avaluacioDialog.responsabilitatsProfessionals' | translate }}" name="responsabilitat_tecnica" [(ngModel)]="editAvaluaData.responsabilitat_tecnica">
          <mat-select-trigger>
            <span class="select-trigger"
              [ngStyle]="{
              'background-color': getColorPerValor(editAvaluaData.responsabilitat_tecnica),
              'padding': '4px 8px',
              'display': 'inline-block',
              'border-radius': '4px',
              'color': 'white',
              'width': '90%',
'min-height': '24px'
              }"
            >
            {{ getNomPerValor(editAvaluaData.responsabilitat_tecnica) }}
            </span>
          </mat-select-trigger>
        <mat-option *ngFor="let opcio of opcions"
              [value]="opcio.valor" [ngStyle]="{'background-color': opcio.color}">
              {{ opcio.nom }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="float:left;clear:left;width:250px">
       <mat-select style="width:250px" placeholder="{{ 'avaluacioDialog.organigrama' | translate }}" name="organigrama_tecnica" [(ngModel)]="editAvaluaData.organigrama_tecnica">
        <mat-select-trigger>
            <span class="select-trigger"
              [ngStyle]="{
              'background-color': getColorPerValor(editAvaluaData.organigrama_tecnica),
              'padding': '4px 8px',
              'display': 'inline-block',
              'border-radius': '4px',
              'color': 'white',
              'width': '90%',
'min-height': '24px'
              }"
            >
            {{ getNomPerValor(editAvaluaData.organigrama_tecnica) }}
            </span>
          </mat-select-trigger>
          <mat-option *ngFor="let opcio of opcions"
              [value]="opcio.valor" [ngStyle]="{'background-color': opcio.color}">
              {{ opcio.nom }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="float:left;clear:left;width:250px">
       <mat-select style="width:250px" placeholder="{{ 'avaluacioDialog.cronograma' | translate }}" name="cronograma_tecnica" [(ngModel)]="editAvaluaData.cronograma_tecnica">
          <mat-select-trigger>
            <span class="select-trigger"
              [ngStyle]="{
              'background-color': getColorPerValor(editAvaluaData.cronograma_tecnica),
              'padding': '4px 8px',
              'display': 'inline-block',
              'border-radius': '4px',
              'color': 'white',
              'width': '90%',
'min-height': '24px'
              }"
            >
            {{ getNomPerValor(editAvaluaData.cronograma_tecnica) }}
            </span>
          </mat-select-trigger>
        <mat-option *ngFor="let opcio of opcions"
              [value]="opcio.valor" [ngStyle]="{'background-color': opcio.color}">
              {{ opcio.nom }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="float:left;clear:left;width:250px">
       <mat-select style="width:250px" placeholder="{{ 'avaluacioDialog.formulariPressupost' | translate }}" name="pressupost_tecnica" [(ngModel)]="editAvaluaData.pressupost_tecnica">
          <mat-select-trigger>
            <span class="select-trigger"
              [ngStyle]="{
              'background-color': getColorPerValor(editAvaluaData.pressupost_tecnica),
              'padding': '4px 8px',
              'display': 'inline-block',
              'border-radius': '4px',
              'color': 'white',
              'width': '90%',
'min-height': '24px'
              }"
            >
            {{ getNomPerValor(editAvaluaData.pressupost_tecnica) }}
            </span>
          </mat-select-trigger>
          <mat-option *ngFor="let opcio of opcions"
              [value]="opcio.valor" [ngStyle]="{'background-color': opcio.color}">
              {{ opcio.nom }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div style="float:left;clear:left;width:100%;font-weight:bold;">
        {{ 'avaluacioDialog.lliuramentSection' | translate }}
      </div>
      <mat-form-field style="float:left;clear:left;width:250px">
       <mat-select style="width:250px" placeholder="{{ 'avaluacioDialog.revisioFormatsQualitat' | translate }}" name="revisio_lliurament" [(ngModel)]="editAvaluaData.revisio_lliurament">
          <mat-select-trigger>
            <span class="select-trigger"
              [ngStyle]="{
              'background-color': getColorPerValor(editAvaluaData.revisio_lliurament),
              'padding': '4px 8px',
              'display': 'inline-block',
              'border-radius': '4px',
              'color': 'white',
              'width': '90%',
'min-height': '24px'
              }"
            >
            {{ getNomPerValor(editAvaluaData.revisio_lliurament) }}
            </span>
          </mat-select-trigger>
        <mat-option *ngFor="let opcio of opcions"
              [value]="opcio.valor" [ngStyle]="{'background-color': opcio.color}">
              {{ opcio.nom }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="float:left;clear:left;width:250px">
       <mat-select style="width:250px" placeholder="{{ 'avaluacioDialog.controlQualitat' | translate }}" name="control_lliurament" [(ngModel)]="editAvaluaData.control_lliurament">
          <mat-select-trigger>
            <span class="select-trigger"
              [ngStyle]="{
              'background-color': getColorPerValor(editAvaluaData.control_lliurament),
              'padding': '4px 8px',
              'display': 'inline-block',
              'border-radius': '4px',
              'color': 'white',
              'width': '90%',
'min-height': '24px'
              }"
            >
            {{ getNomPerValor(editAvaluaData.control_lliurament) }}
            </span>
          </mat-select-trigger>
        <mat-option *ngFor="let opcio of opcions"
              [value]="opcio.valor" [ngStyle]="{'background-color': opcio.color}">
              {{ opcio.nom }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="float:left;clear:left;width:250px">
       <mat-select style="width:250px" placeholder="{{ 'avaluacioDialog.lliuramentClient' | translate }}" name="client_lliurament" [(ngModel)]="editAvaluaData.client_lliurament">
          <mat-select-trigger>
            <span class="select-trigger"
              [ngStyle]="{
              'background-color': getColorPerValor(editAvaluaData.client_lliurament),
              'padding': '4px 8px',
              'display': 'inline-block',
              'border-radius': '4px',
              'color': 'white',
              'width': '90%',
'min-height': '24px'
              }"
            >
            {{ getNomPerValor(editAvaluaData.client_lliurament) }}
            </span>
          </mat-select-trigger>
        <mat-option *ngFor="let opcio of opcions"
              [value]="opcio.valor" [ngStyle]="{'background-color': opcio.color}">
              {{ opcio.nom }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="float:left;clear:left;width:250px">
       <mat-select style="width:250px" placeholder="{{ 'avaluacioDialog.lliuramentSocis' | translate }}" name="soci_lliurament" [(ngModel)]="editAvaluaData.soci_lliurament">
          <mat-select-trigger>
            <span class="select-trigger"
              [ngStyle]="{
              'background-color': getColorPerValor(editAvaluaData.soci_lliurament),
              'padding': '4px 8px',
              'display': 'inline-block',
              'border-radius': '4px',
              'color': 'white',
              'width': '90%',
'min-height': '24px'
              }"
            >
            {{ getNomPerValor(editAvaluaData.soci_lliurament) }}
            </span>
          </mat-select-trigger>
        <mat-option *ngFor="let opcio of opcions"
              [value]="opcio.valor" [ngStyle]="{'background-color': opcio.color}">
              {{ opcio.nom }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div style="float:left;clear:left;width:100%;font-weight:bold;">
        {{ 'avaluacioDialog.arxiuSection' | translate }}
      </div>
      <mat-form-field style="float:left;clear:left;width:250px">
       <mat-select style="width:250px" placeholder="{{ 'avaluacioDialog.introduccioDadesSg' | translate }}" name="arxiu_sg" [(ngModel)]="editAvaluaData.arxiu_sg">
          <mat-select-trigger>
            <span class="select-trigger"
              [ngStyle]="{
              'background-color': getColorPerValor(editAvaluaData.arxiu_sg),
              'padding': '4px 8px',
              'display': 'inline-block',
              'border-radius': '4px',
              'color': 'white',
              'width': '90%',
'min-height': '24px'
              }"
            >
            {{ getNomPerValor(editAvaluaData.arxiu_sg) }}
            </span>
          </mat-select-trigger>
        <mat-option *ngFor="let opcio of opcions"
              [value]="opcio.valor" [ngStyle]="{'background-color': opcio.color}">
              {{ opcio.nom }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="float:left;clear:left;width:250px">
       <mat-select style="width:250px" placeholder="{{ 'avaluacioDialog.arxiuServidor' | translate }}" name="arxiu_servidor" [(ngModel)]="editAvaluaData.arxiu_servidor">
          <mat-select-trigger>
            <span class="select-trigger"
              [ngStyle]="{
              'background-color': getColorPerValor(editAvaluaData.arxiu_servidor),
              'padding': '4px 8px',
              'display': 'inline-block',
              'border-radius': '4px',
              'color': 'white',
              'width': '90%',
'min-height': '24px'
              }"
            >
            {{ getNomPerValor(editAvaluaData.arxiu_servidor) }}
            </span>
          </mat-select-trigger>
        <mat-option *ngFor="let opcio of opcions"
              [value]="opcio.valor" [ngStyle]="{'background-color': opcio.color}">
              {{ opcio.nom }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="float:left;clear:left;width:250px">
         <textarea matInput style="width:240px;height:'100px';backgroundColor:'#dee8f4'" [(ngModel)]="editAvaluaData.nota" name="nota" placeholder="{{ 'documents.colNota' | translate }}"></textarea>
      </mat-form-field>
      <div style="float:left;clear:left;color:red;font-style:italic;padding:0px"><sup>*</sup> {{ 'avaluacioDialog.avisEsborrarCamp' | translate }}</div>
      <div style="height:50px">&nbsp;</div>
    </mat-card-content>
  </form>
</mat-card>
